module.exports = __webpack_public_path__ + "img/cancelled-order-icon.4bee29f4.svg";